<style type="text/scss" lang="scss">
  @import '../../styles/vars';
  .input-date {
    :global(input) {
      appearance: none;
      background: #f7f7f8;
      border: none;
      box-shadow: none;
      border-radius: 4px;
      font-family: 'Lato', sans-serif;
      color: #1c1c1b;
      font-weight: 500;
      font-size: 15px;
      margin: 0;

      &:focus {
        outline: none;
        border: none;
        box-shadow: none;
        background-color: darken(#f7f7f8, 2);
      }
    }
  }
</style>

<script>
  import Flatpickr from 'svelte-flatpickr';
  import moment from 'moment';

  export let value;
  export let label = null;
  export let placeholder = '';



  value = value ? moment(value).toDate() : null;

  let pickrOptions = {
    enableTime: true,
    altInput: true,
    altFormat: 'l, F J, Y h:i K',
    parseDate(date) {
      if (!date) {
        return null
      }

      if (date === 'Invalid date') {
        return null
      }

      return moment(date).toDate()
    }
  };
</script>

<div class="input-date">
  {#if label}<label>{label}</label>{/if}
  <Flatpickr options="{pickrOptions}" bind:value="{value}" placeholder="{placeholder}"></Flatpickr>
</div>